/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { DetailsBooking } from 'types';
import { getBookingDetailsPageLink } from 'lib/links';

export const useCanRequestAmendDatesGuard = (booking: DetailsBooking) => {
  const { replace } = useHistory();

  useEffect(() => {
    if (!booking.flags.isChangeDatesRequestEnabled) {
      replace(getBookingDetailsPageLink(booking.id));
    }
  }, []);
};
